import { render, staticRenderFns } from "./ClienteTabList.vue?vue&type=template&id=c7d81f30&scoped=true"
import script from "./ClienteTabList.vue?vue&type=script&lang=js"
export * from "./ClienteTabList.vue?vue&type=script&lang=js"
import style0 from "./ClienteTabList.vue?vue&type=style&index=0&id=c7d81f30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d81f30",
  null
  
)

export default component.exports